import { useEffect, useState } from 'react'
import { DEFAULT_DATE_PERIOD_IN_MS, DEFAULT_RIC_LOCATION, isPhone } from '../common/constants'
import { TEMP_MAP_CENTER } from '../common/data'
import { Map, ChartsPageTimeController } from '../components'
import { useAccountContext, useAppContext } from '../contexts'
import { ChartsPage } from './ChartsPage'
import { Layout } from '../layouts/Layout'
import { Viewport } from '../common/types'

export function MapPage() {
  const { devices, selectedDevice, selectDevice, selectDeviceLocally } = useAccountContext()
  const { showCharts } = useAppContext()

  const [focus, setFocus] = useState(TEMP_MAP_CENTER)
  const [viewport, setViewport] = useState<Viewport>({
    minimum: new Date().setHours(0, 0, 0, 0) - DEFAULT_DATE_PERIOD_IN_MS,
    maximum: new Date().setHours(23, 59, 59, 999),
  })

  useEffect(() => {
    !isPhone && selectDevice('')
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let active = true
    if (selectedDevice !== '' && devices[selectedDevice]) {
      const { coordinateNSValue, coordinateEWValue } = devices[selectedDevice]
      if (coordinateNSValue && coordinateEWValue) {
        const lat = coordinateNSValue || DEFAULT_RIC_LOCATION.lat
        const lng = coordinateEWValue || DEFAULT_RIC_LOCATION.lng
        const location = { lat, lng }
        if (active) {
          setFocus(location)
        }
      }
    } else {
      if (active) {
        setFocus(DEFAULT_RIC_LOCATION)
      }
    }

    return () => {
      active = false
    }
  }, [selectedDevice]) // eslint-disable-line react-hooks/exhaustive-deps

  function updateDay(start: number, end: number, isToday: boolean) {
    setViewport({ minimum: start, maximum: end })
  }

  return (
    <Layout>
      <div>
        {showCharts ? (
          <>
            <div className="flex flex-row">
              <ChartsPageTimeController updateDay={updateDay} />
            </div>
            <div className="overflow-y-auto overflow">
              <ChartsPage sigfoxId={selectedDevice} viewport={viewport} />
            </div>
          </>
        ) : (
          <div className="ml-2">
            <Map focus={focus} selectDevice={selectDeviceLocally} />
          </div>
        )}
      </div>
    </Layout>
  )
}
